/** 빌드 시점 설정(.env.*). 비밀값은 여기에 두지 않는다 — 브라우저에 그대로 노출된다. */
const env = import.meta.env;

export const config = {
  /** cognito = 실제 AWS, dev = 로컬 메모리 API, demo = 단일 HTML(브라우저 안에서 API 실행) */
  authMode: (env.VITE_AUTH_MODE === 'dev' || env.VITE_AUTH_MODE === 'demo' ? env.VITE_AUTH_MODE : 'cognito') as 'dev' | 'demo' | 'cognito',
  apiUrl: String(env.VITE_API_URL ?? '').replace(/\/$/, ''),
  userPoolId: String(env.VITE_COGNITO_USER_POOL_ID ?? ''),
  clientId: String(env.VITE_COGNITO_CLIENT_ID ?? ''),
  /** 공용 PC 를 고려한 무조작 자동 로그아웃(분) */
  idleMinutes: 30,
  /** 고객센터(Google Workspace 별칭 → selfon@selfon.io) */
  supportEmail: 'help@selfon.io',
  /** 개인정보처리방침에 공개하는 개인정보 보호책임자 */
  privacyOfficer: { name: '이의성', title: '대표' },
};

export function configProblems(): string[] {
  const out: string[] = [];
  if (config.authMode === 'demo') return out;
  if (!config.apiUrl) out.push('VITE_API_URL 이 비어 있습니다.');
  if (config.authMode === 'cognito' && (!config.userPoolId || !config.clientId)) out.push('Cognito 설정(VITE_COGNITO_USER_POOL_ID, VITE_COGNITO_CLIENT_ID)이 비어 있습니다.');
  return out;
}
